const round = (n: number | null | undefined, point: number = 1) =>
  n ? Math.round(n * Math.pow(10, point)) / Math.pow(10, point) : null;

export default round;
